"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryControlContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _SvgIconAlertTriangle = require("../svg/feathers/SvgIconAlertTriangle");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c2d689f20{display:block}.c2cd7badb{font-size:.875rem;font-weight:500;line-height:1.25rem;color:var(--color-black-d);padding-bottom:.5rem}.c399e866b{display:flex;align-items:center}.cfe127a15{font-size:.875rem;font-weight:400;line-height:1.25rem;padding-right:.625rem;flex-grow:0;flex-shrink:0}.c90c953fa{flex-grow:1;flex-shrink:1}.c49ff1e90{font-size:.5625rem;font-weight:400;line-height:.75rem;color:var(--color-gray-70);display:flex;align-items:center;justify-content:flex-end;padding-top:.25rem}.cdc13ca48{font-size:.75rem;font-weight:400;line-height:1rem;color:var(--color-gray-70);padding-top:.3125rem}.cdd5a8e55{padding-top:.625rem;color:var(--color-red-90);display:flex;align-items:center}.cc609ccae{padding-right:.375rem}.c47b3a999{font-size:.875rem;font-weight:500;line-height:1.25rem}");
var styles = {
  root: 'c2d689f20',
  title: 'c2cd7badb',
  body: 'c399e866b',
  label: 'cfe127a15',
  control: 'c90c953fa',
  tip: 'c49ff1e90',
  description: 'cdc13ca48',
  warning: 'cdd5a8e55',
  icon: 'cc609ccae',
  message: 'c47b3a999'
};

var SecondaryControlContainer = function SecondaryControlContainer(props, ref) {
  var children = props.children,
      label = props.label,
      classes = props.classes,
      title = props.title,
      labelProps = props.labelProps,
      tip = props.tip,
      description = props.description,
      warning = props.warning;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root)
  }, !title ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, title), !label ? children : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.body
  }, /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({
    className: cn.label
  }, labelProps), label), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.control
  }, children)), !tip ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.tip
  }, tip), !description ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.description
  }, description), !warning ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.warning
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, /*#__PURE__*/_react.default.createElement(_SvgIconAlertTriangle.SvgIconAlertTriangle, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.message
  }, warning)));
};

exports.SecondaryControlContainer = SecondaryControlContainer;
SecondaryControlContainer.propTypes = {
  /* component logic props */
  title: _propTypes.node,
  label: _propTypes.node,
  tip: _propTypes.node,
  description: _propTypes.node,
  warning: _propTypes.node,
  labelProps: _propTypes.object,
  children: _propTypes.node.isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondaryControlContainer.defaultProps = {
  title: null,
  label: null,
  tip: null,
  description: null,
  warning: null,
  classes: {},
  labelProps: {}
};